import isFiniteNumber from './isFiniteNumber';

/**
 * @param {*} value
 * @param {number} minimum
 * @returns {?number}
 */
export default function resolveBoundedInteger(value, minimum) {
    if (typeof value !== 'number' && typeof value !== 'string') {
        return null;
    }

    const number = Number(value);

    if (
        !isFiniteNumber(number)
        || Math.floor(number) !== number
        || number < minimum
        || number > Number.MAX_SAFE_INTEGER
    ) {
        return null;
    }

    return number;
}
